<section class="appointment-period-dialog">
	<form [formGroup]="form" (ngSubmit)="save()">

    <div class="section">
			<label class="section-label">{{ 'availability.date-range' | translate }}</label>
			<div class="row">
				<span class="field">
					<small>
            {{ 'appointment-period.start-date' | translate }}
            <span class="p-error mandatory-field-indicator">*</span>
          </small>
					<app-datepicker-input formControlName="startDate" [includeTime]="false"></app-datepicker-input>
				</span>
				<span class="field">
					<small>
            {{ 'appointment-period.end-date' | translate }}
            <span class="p-error mandatory-field-indicator">*</span>
          </small>
					<app-datepicker-input formControlName="endDate" [includeTime]="false"></app-datepicker-input>
				</span>
			</div>
		</div>

		<div class="section">
			<label class="section-label">
        {{ 'appointment-period.weekdays' | translate }}
        <span class="p-error mandatory-field-indicator">*</span>
      </label>
			<div class="weekdays" formGroupName="weekdays">
				@for (weekday of weekdays; track weekday.key) {
					<span class="weekday">
						<p-checkbox
							[binary]="true"
							[formControlName]="weekday.key"
							[inputId]="'appointment-' + weekday.key"
              class="mr-0"
						></p-checkbox>
						<label [for]="'appointment-' + weekday.key">{{ weekday.label | translate }}</label>
					</span>
				}
			</div>
		</div>

		<div class="section">
			<label class="section-label">{{ 'availability.time-range' | translate }}</label>
			<div class="row">
				<span class="field">
					<small>
            {{ 'appointment-period.start-time' | translate }}
            <span class="p-error mandatory-field-indicator">*</span>
          </small>
					<input type="time" pInputText formControlName="startTime" (change)="onTimeSelect($event, 'startTime')" />
				</span>
				<span class="field">
					<small>
            {{ 'appointment-period.end-time' | translate }}
            <span class="p-error mandatory-field-indicator">*</span>
          </small>
					<input type="time" pInputText formControlName="endTime" (change)="onTimeSelect($event, 'endTime')" />
				</span>
			</div>
		</div>

    <div class="section fields-grid">
			<span class="field">
				<small for="appointment-user-id">
          {{ 'event.staff' | translate }}
          <span class="p-error mandatory-field-indicator">*</span>
        </small>
        <p-select
          id="appointment-user-id"
          [hidden]="!userOptions"
          [options]="userOptions || []"
          formControlName="userId"
          [optionLabel]="'title'"
          [optionValue]="'id'"
          data-cy="user-resource"
        ></p-select>
			</span>
      <span class="field"></span>
		</div>

    <div class="section fields-grid">
      <span class="field">
        <small for="appointment-package-user-type">
          {{ 'event.professional-group' | translate }}
          <span class="p-error mandatory-field-indicator">*</span>
        </small>
        <p-select
          id="appointment-package-user-type"
          [options]="packageUserTypes"
          [optionLabel]="'description'"
          [optionValue]="'code'"
          formControlName="productPackageUserType"
          [showClear]="true"
          class="w-100"
          appendTo="body"
          styleClass="e2e-event-description"
          (onChange)="onPackageUserTypeSelect($event.value)"
        ></p-select>
      </span>
    </div>

    <div class="section">
      @if(filteredProductPackages && filteredProductPackages.length > 0) {
        <span class="field">
          <small for="appointment-package-id">{{ 'event.description' | translate }}</small>
          <p-select
            id="appointment-package-id"
            [options]="filteredProductPackages"
            [optionLabel]="'name'"
            [optionValue]="'id'"
            formControlName="productPackageId"
            [showClear]="true"
            class="w-100"
            appendTo="body"
            styleClass="e2e-event-description"
          ></p-select>
        </span>
      }
    </div>

    <div class="section">
			<div class="row">
				<span class="field numeric-field">
					<small>{{ 'appointment-period.suggestion-time' | translate }}</small>
          <app-setting-dropdown
            fieldName="suggestion-time"
            settingName="PACKAGE_EVENT_DURATION"
            [defaultValue]="form.get('suggestionTime')?.value ?? null"
            styleClass="w-full"
            (settingChanged)="form.get('suggestionTime')?.setValue($event)"
          ></app-setting-dropdown>
				</span>
			</div>
		</div>

    @if (!isEdit) {
			<div class="section">
				<label class="section-label">{{ 'appointment-period.breaks' | translate }}</label>
				<div formArrayName="breaks">
					@for (b of breaks.controls; track $index) {
						<div class="row break-row" [formGroupName]="$index">
							<span class="field">
								<small>{{ 'appointment-period.break-start' | translate }}</small>
								<input type="time" pInputText formControlName="startTime" />
							</span>
							<span class="field">
								<small>{{ 'appointment-period.break-duration' | translate }}</small>
								<p-inputNumber
									formControlName="durationMinutes"
									[min]="1"
									[step]="5"
									[showButtons]="true"
									suffix=" min"
								></p-inputNumber>
							</span>
							<button
								pButton
								type="button"
								class="p-button-danger p-button-text remove-break mb-3"
								icon="pi pi-times"
								[title]="'appointment-period.remove-break' | translate"
								(click)="removeBreak($index)"
							></button>
						</div>
					}
				</div>
				<button
					pButton
					type="button"
					class="p-button-secondary p-button-sm"
					icon="pi pi-plus"
					(click)="addBreak()"
				>
					{{ 'appointment-period.add-break' | translate }}
				</button>
			</div>
		}

		<div class="section">
			<small for="appointment-info">{{ 'common.description' | translate }}</small>
			<textarea pTextarea id="appointment-info" formControlName="info" [rows]="3"></textarea>
		</div>

		<div class="actions">
			<button pButton type="submit" class="p-button-primary" [disabled]="saving">
				{{ 'common.button.save' | translate }}
			</button>
			@if (isEdit && form.get('id')) {
				<button pButton type="button" class="p-button-danger" [disabled]="saving" (click)="onDelete()">
					{{ 'common.button.delete' | translate }}
				</button>
			}
			<button pButton type="button" class="p-button-secondary" [disabled]="saving" (click)="doClose()">
				{{ 'common.button.cancel' | translate }}
			</button>
		</div>
	</form>
</section>
